import { Button, Loader, Modal } from "rsuite";

const CustomModal = ({
  title = "Titre",
  size = "lg",
  state,
  handleClose,
  ActionOnClose,
  save,
  noModify = false,
  children,
  footer,
}) => {
  return (
    <Modal
      size={size}
      overflow={false}
      style={{
        maxHeight: "calc(100vh - 50px)",
        overflow: "auto",
        maxWidth: "100vw",
      }}
      open={state.open}
      onClose={() => {
        handleClose();
        if (ActionOnClose) ActionOnClose();
      }}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            maxHeight: "calc(100vh - 240px)",
            overflow: "auto",
            maxWidth: "100vw",
          }}
        >
          {children}
        </div>
      </Modal.Body>

      <Modal.Footer>
        {!noModify && footer && (
          <Button onClick={save} appearance="primary">
            {state.loading ? <Loader size="sm" /> : "Enregistrer"}
          </Button>
        )}
        <Button
          onClick={() => {
            handleClose();
            if (ActionOnClose) ActionOnClose();
          }}
          appearance="subtle"
        >
          Annuler
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
